module.exports = __webpack_public_path__ + "img/stone-pine.fa2f04ae.jpg";